import FormBtn from "app/Components/CommanComponents/FormBtn";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { initialMedicalValidation, initialTrainingValidation } from "./Constant";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import FormTextArea from "app/Components/_form/FormTextArea/FormTextArea";
import InputError from "app/Components/_form/InputError/InputError";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { siteTypeList } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Card, Col, FormGroup, Row, Button } from "react-bootstrap";
import { WidgetBox, employeeEmploymentStatusList, employeeFormLabel } from "./Constant";
import Label from "app/Components/_form/Label/Label";
import InitialTrainingForm from "./Component/InitialTrainingForm";
import {
  DDMMYYYYFormat,
  disableFutureDate,
  isAfter,
  isSameOrAfter,
} from "app/_helpers/dateHelper";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";
import InitialMedicalForm from "./Component/InitialMedicalForm";
import { confirmAlert } from "react-confirm-alert";
import {
  getEmployeeByID,
  updateEmployeeEmploymentStatusOfEmployee,
} from "app/_services/UserManagement/EmployeeService";
import { useHistory, useParams } from "react-router-dom";
import toastr from "toastr";
import EmployeeId from "./Component/EmployeeId";
import ConfirmationModal from "./Component/ConfimationModal";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import StatusHistoryList from "./Component/StatusHistoryList";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function EmployeeEmploymentForm() {
  const [form, setForm] = useState({});
  const [staticForm, setStaticForm] = useState({});
  const [error, setError] = useState({});
  const [confirmation, setConfirmation] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const history = useHistory();
  const { goBack } = useHistory();

  /***************** Api Call ********************/
  const getFormData = useCallback(async () => {
    getEmployeeByID(id).then((response) => {
      if (!response?.status) {
        history.push("/user-management/employee");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm({
        ...response.data.employees,
        siteType: response.data.employees?.ehsSite?.siteType || "",
        isPmeDate: response.data.employees?.isPmeDate ? true : false,
        pmeDate: response.data.employees?.lastPMEDate,
        isRefresherDate: response.data.employees?.isRefresherDate || false,
        retireResignDate: response.data.employees?.dateOfSeparation,
        // isPmeDate: row?.isPmeDate || false,
        // isRefresherDate: row?.isRefresherDate || false,
        isIMEDate: response.data.employees?.isIMEDate ? true : false,
        imeDate: response.data.employees?.lastIMEDate,
      });
      setStaticForm({
        ...response.data.employees,
        siteType: response.data.employees?.ehsSite?.siteType || "",
        isPmeDate: response.data.employees?.isPmeDate ? true : false,
        pmeDate: response.data.employees?.lastPMEDate,
        isIMEDate: response.data.employees?.isIMEDate ? true : false,
        imeDate: response.data.employees?.lastIMEDate,
      });
    });
  }, [id]);

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};
    if (
      name === "employmentStatus" &&
      value !== form?.employmentStatus &&
      value === "active"
    ) {
      extraToChange.dateOfSeparation = "";
      extraToChange.remark = "";
    }

    if (
      name === "employmentStatus" &&
      value !== form?.employmentStatus &&
      value !== "active"
    ) {
      extraToChange.dateOfReJoining = "";
    }

    if (name === "currentWorkLocation" && value !== form?.currentWorkLocation) {
      if (
        siteList
          .filter((d) => d.siteType === 3)
          .map((d) => d.id)
          .includes(+value)
      ) {
        if (!form?.lastIMEDate && !form?.lastPMEDate) {
          extraToChange.mineTag = "yes";
          extraToChange.trainingEligibility = "";
          extraToChange.trainingDesignation = "";
          // extraToChange.isPmeDate = false;
          // extraToChange.pmeDate = "";
          extraToChange.specialMedicalExamEligibility = "";
          extraToChange.specialMedicalExamCategory = "";
        } else extraToChange.mineTag = "yes";
      } else {
        extraToChange.mineTag = "no";
        extraToChange.startDateAtMines = "";
      }
    }

    if (name === "siteType" && value !== form?.siteType) {
      extraToChange.currentWorkLocation = "";
      extraToChange.startDateAtMines = "";
      extraToChange.endDateAtMines = "";
      extraToChange.mineTag = "no";
    }

    if (name === "trainingEligibility" && value !== "yes") {
      extraToChange.trainingDesignation = "";
    }

    if (name === "isPmeDate" && value !== form?.isPmeDate) {
      extraToChange.pmeDate = "";
      extraToChange.pmeCertificateNo = "";
    }

    if (name === "specialMedicalExamEligibility" && value !== "yes") {
      extraToChange.specialMedicalExamCategory = "";
    }
    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);
  useEffect(() => {
    getAllSiteList();
  }, [getAllSiteList]);
  const onSubmit = useCallback(
    async (e, checkExisting = true) => {
      if (e) e.preventDefault();

      let query = "checkPreviousRecord=true";
      let errorObj = {};

      if (["resigned", "retired"].includes(form?.employmentStatus)) {
        if (!form?.dateOfSeparation)
          errorObj["dateOfSeparation"] =
            employeeFormLabel["dateOfSeparation"] + " is Required.";

        if (!form?.remark)
          errorObj["remark"] = employeeFormLabel["remark"] + " is Required.";
      }
      if (form?.employmentStatus === "active") {
        if (!form?.dateOfReJoining)
          errorObj["dateOfReJoining"] =
            employeeFormLabel["dateOfJoining"] + " is Required.";

        if (form.siteType) {
          if (!form.currentWorkLocation) {
            errorObj["currentWorkLocation"] =
              employeeFormLabel["currentWorkLocation"] + " is Required.";
          }
          if (!form.startDateAtMines)
            errorObj["startDateAtMines"] =
              employeeFormLabel["startDateAtMines"] + " is Required.";
          if (
            form?.dateOfJoining &&
            form?.startDateAtMines &&
            isAfter(form?.dateOfJoining, form?.startDateAtMines)
          ) {
            errorObj["startDateAtMines"] =
              employeeFormLabel["startDateAtMines"] +
              " Can't Before " +
              employeeFormLabel["dateOfJoining"];
          }
        } else {
          errorObj["siteType"] = employeeFormLabel["siteType"] + " is Required.";
        }

        if (showTraining) {
          errorObj = initialTrainingValidation(errorObj, form);
        }

        if (form.siteType === 3) {
          errorObj = initialMedicalValidation(errorObj, form);
        }
      }

      setError((prev) => ({
        ...errorObj,
      }));

      if (Object.values(errorObj).filter((d) => d !== "").length) return;
      setLoading(true);

      let joiningDate = form.dateOfReJoining || form.dateOfJoining;
      let formObj = {};
      if (form.employmentStatus !== "active") {
        let extraObj = {
          remark: form?.remark,
          dateOfSeparation: form?.dateOfSeparation,
          employmentStatus: form?.employmentStatus,
        };
        formObj = JSON.parse(JSON.stringify({ ...staticForm, ...extraObj }));
      } else
        formObj = JSON.parse(JSON.stringify({ ...form, dateOfJoining: joiningDate }));
      let response = {};
      if (checkExisting) {
        response = await updateEmployeeEmploymentStatusOfEmployee(
          id,
          {
            employee: formObj,
          },
          query
        );
      } else {
        response = await updateEmployeeEmploymentStatusOfEmployee(id, {
          employee: formObj,
        });
      }
      if (!response?.status) {
        setLoading(false);
        return toastr.error(response?.message);
      }

      if (response?.data?.existingData) {
        setConfirmMsg(response?.data?.existingData);
        setConfirmation(true);
        setLoading(false);
        return;
      } else {
        setConfirmation(false);
      }
      setLoading(false);
      toastr.success(response.message || "Success.");
      // push(`/user-management/employee`);
      getFormData();
    },
    [form, getFormData, id, staticForm]
  );

  useEffect(() => {
    if (!id) return;

    getFormData();
  }, [getFormData, id]);

  const onHideConfirmation = () => {
    setConfirmation(false);
  };
  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "Change Status",
      message: "Are you sure you want to proceed with employee status update",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => {
            onSubmit(e, false);
          },
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  }, [onSubmit]);
  const showTraining = useMemo(
    () => form.siteType === 3,
    // initialForm.siteType !== 3 &&
    //!form?.basicTrainingCompletionDate,
    [form.siteType]
  );

  const showMedical = useMemo(
    () =>
      form.siteType === 3 &&
      // initialForm.siteType !== 3 &&
      !form?.lastIMEDate,
    //!form?.lastPMEDate,
    [form?.lastIMEDate, form.siteType]
  );
  useEffect(() => {
    if (form?.dateOfReJoining)
      setForm((prev) => {
        return { ...prev, startDateAtMines: "" };
      });
  }, [form?.dateOfReJoining]);

  return (
    <div>
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">Edit employment status</h3>
            <EmployeeId id={id} form={staticForm} employeeId={form.employeeId} />
          </Card.Title>

          <WidgetBox form={staticForm} />
          <ViewBasicDetailsComponent form={form} />

          {isActive ? (
            <>
              {!loading ? (
                <>
                  {" "}
                  <div>
                    <h5>Employment Details</h5>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>{employeeFormLabel["employmentStatus"]}</Label>
                          <SimpleSelect
                            name={"employmentStatus"}
                            value={form.employmentStatus}
                            options={employeeEmploymentStatusList}
                            onChange={onChange}
                            label="name"
                            id="value"
                            placeHolder={employeeFormLabel["employmentStatus"]}
                            error={error["employmentStatus"]}
                          />
                          <InputError error={error["employmentStatus"]} />
                        </FormGroup>
                      </Col>
                      {form.employmentStatus === "active" ? (
                        <Col md={4}>
                          <FormGroup>
                            <Label>{employeeFormLabel["dateOfJoining"]}</Label>
                            <DatePicker
                              name={"dateOfReJoining"}
                              value={form.dateOfReJoining}
                              onChangeDate={onChange}
                              label={employeeFormLabel["dateOfJoining"]}
                              placeHolder={employeeFormLabel["dateOfJoining"]}
                              error={error["dateOfReJoining"]}
                              // disabled={!form.employmentStatus}
                              isValidDate={(e) =>
                                form?.retireResignDate
                                  ? e.isAfter(form?.retireResignDate)
                                  : true
                              }
                            />
                            <InputError error={error["dateOfReJoining"]} />
                          </FormGroup>
                        </Col>
                      ) : (
                        <></>
                      )}

                      {!(!form.employmentStatus || form.employmentStatus === "active") ? (
                        <>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{employeeFormLabel["dateOfSeparation"]}</Label>

                              <DatePicker
                                name={"dateOfSeparation"}
                                value={form.dateOfSeparation}
                                onChangeDate={onChange}
                                label={employeeFormLabel["dateOfSeparation"]}
                                placeHolder={employeeFormLabel["dateOfSeparation"]}
                                error={error["dateOfSeparation"]}
                                disabled={
                                  !form.employmentStatus ||
                                  form.employmentStatus === "active"
                                }
                                isValidDate={(e) => {
                                  return e.isSameOrAfter(staticForm?.startDateAtMines);
                                }}
                              />
                              <InputError error={error["dateOfSeparation"]} />
                            </FormGroup>
                          </Col>

                          <Col md={6}>
                            <FormTextArea
                              label={employeeFormLabel["remark"]}
                              name={"remark"}
                              onChange={onChange}
                              value={form.remark}
                              // disabled={disabledForm}
                            />

                            <InputError error={error["remark"]} />
                          </Col>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                    {!form.employmentStatus || form.employmentStatus === "active" ? (
                      <>
                        <div className="mt-2">
                          <h5>New Location</h5>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <Label>{employeeFormLabel["siteType"]}</Label>

                                <SimpleSelect
                                  name={"siteType"}
                                  value={form.siteType}
                                  onChange={onChange}
                                  options={siteTypeList}
                                  label={"name"}
                                  id="value"
                                  placeHolder={employeeFormLabel["siteType"]}
                                  error={error["siteType"]}
                                />
                                <InputError error={error["siteType"]} />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label>{employeeFormLabel["currentWorkLocation"]}</Label>

                                <SimpleSelect
                                  name={"currentWorkLocation"}
                                  value={form.currentWorkLocation}
                                  onChange={onChange}
                                  options={
                                    form.siteType
                                      ? siteList
                                          .filter((d) => d.siteType === +form.siteType)
                                          .map((d) => ({
                                            name: `${d.name}`,
                                            value: d.id,
                                          }))
                                      : []
                                  }
                                  label={"name"}
                                  disabled={!form.siteType}
                                  id="value"
                                  placeHolder={employeeFormLabel["currentWorkLocation"]}
                                  error={error["currentWorkLocation"]}
                                />
                                <InputError error={error["currentWorkLocation"]} />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>{employeeFormLabel["startDateAtMines"]}</Label>

                                <DatePicker
                                  name={"startDateAtMines"}
                                  value={form.startDateAtMines}
                                  onChangeDate={onChange}
                                  label={employeeFormLabel["startDateAtMines"]}
                                  placeHolder={employeeFormLabel["startDateAtMines"]}
                                  error={error["startDateAtMines"]}
                                  disabled={!form.siteType}
                                  isValidDate={(e) => {
                                    return e.isSameOrAfter(form?.dateOfReJoining);
                                  }}
                                />
                                <InputError error={error["startDateAtMines"]} />
                              </FormGroup>
                            </Col>

                            <Col md={1}>
                              <FormGroup>
                                <Label>{employeeFormLabel["mineTag"]}</Label>

                                <span>{form.mineTag === "yes" ? "YES" : "NO"}</span>
                                <InputError error={error["mineTag"]} />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>{" "}
                        {!form?.lastIMEDate && !form?.lastPMEDate && (
                          <div>
                            {showTraining && (
                              <InitialTrainingForm
                                form={form}
                                onChange={onChange}
                                error={error}
                              />
                            )}

                            {form.siteType === 3 && (
                              <InitialMedicalForm
                                showMedical={showMedical}
                                form={form}
                                onChange={onChange}
                                error={error}
                              />
                            )}
                          </div>
                        )}
                        <Row>
                          {form?.lastPMEDate && form.siteType === 3 ? (
                            <Col md={4}>
                              <Label>
                                <h5>Last PME Date</h5> {DDMMYYYYFormat(form?.lastPMEDate)}
                              </Label>
                            </Col>
                          ) : (
                            ""
                          )}
                          {form?.lastIMEDate && form.siteType === 3 ? (
                            <Col md={4}>
                              <Label>
                                <h5>Last IME Date</h5> {DDMMYYYYFormat(form?.lastIMEDate)}
                              </Label>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>{" "}
                  <FormBtn
                    id={id}
                    onSubmit={onSubmit}
                    // backUrl={"/user-management/employee"}
                    backOnClick={() => setIsActive(false)}
                    backBtnTitle={"Cancel"}
                  />
                </>
              ) : (
                <NetZeroLoader addZIndex={true} />
              )}
            </>
          ) : (
            ""
          )}

          {!isActive ? (
            <div className={"mt-4 text-center"}>
              <Button onClick={goBack} variant="secondary" className="mr-2">
                {"Back"}
              </Button>

              <Button
                onClick={() => setIsActive(true)}
                variant="primary"
                className="ml-2"
              >
                {"Change Status"}
              </Button>
            </div>
          ) : (
            ""
          )}
          <StatusHistoryList data={form?.dojHistoriesModified || []} />
        </Card.Body>
      </Card>
      {!loading ? (
        <ConfirmationModal
          confirmation={confirmation}
          onHideConfirmation={onHideConfirmation}
          confirmMsg={confirmMsg}
          confirmationAlert={confirmationAlert}
          title={"Employee Status Update"}
          type={"status"}
          modalFor={"employee"}
          checkMedicalForPending={false}
        ></ConfirmationModal>
      ) : (
        ""
      )}
    </div>
  );
}

export default EmployeeEmploymentForm;
